package com.ai.mitra

import kotlin.Boolean
import kotlin.String

internal object BuildKonfig {
  public val GEMINI_API_KEY: String = "AIzaSyCVsKX-amF0yHRnKN5fQM4fGgcVHFAm71M"

  public val isDebug: Boolean = false
}
